import DataSetResponseEditContainer from './data_set_response_edit_container';

const DataSetResponseEdit = DataSetResponseEditContainer;

export default DataSetResponseEdit;
